import getWindowWidthCookie from './get-window-width-cookie';

export default function getWindowWidth(
  windowWidth: number,
  windowWidthSv: number | null
): number {
  const windowWidthCookie = getWindowWidthCookie();

  const isValid = (value: number | null | undefined): value is number => {
    if (typeof value === 'number' && value > 0 && !isNaN(value)) {
      return true;
    }
    return false;
  };

  if (isValid(windowWidth)) return windowWidth;
  if (isValid(windowWidthSv)) return windowWidthSv;
  if (isValid(windowWidthCookie)) return windowWidthCookie;

  return 0;
}
